import { render, staticRenderFns } from "./RoleInfoAddress.vue?vue&type=template&id=a0c11bf8&"
import script from "./RoleInfoAddress.vue?vue&type=script&lang=js&"
export * from "./RoleInfoAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports